class AnnouncementBar extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.currentIndex = 0
    this.timer = null
    this.delay = 5000

    this.initialize()
  }

  setupListeners () {
    super.setupListeners()
  }

  initialize () {
    this.announcements = this.els.announcement.elements

    // Start the cycle
    this.startCycle()

    // Pause on hover (desktop only)
    this.addEventListener('mouseenter', () => this.stopCycle())
    this.addEventListener('mouseleave', () => this.startCycle())
  }

  startCycle () {
    this.stopCycle()
    if (this.announcements.length < 2) return

    this.timer = setInterval(() => this.showNext(), this.delay)
  }

  stopCycle () {
    clearInterval(this.timer)
  }

  showNext () {
    const total = this.announcements.length
    this.announcements[this.currentIndex].setAttribute('aria-hidden', true)
    this.currentIndex = (this.currentIndex + 1) % total
    this.announcements[this.currentIndex].removeAttribute('aria-hidden')
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
